const Allocation = () => import("./views/allocation.vue");
import DashboardLayout from "../../../views/Layout/DashboardLayout.vue";

const moduleRoute = {
  path: "/",
  component: DashboardLayout,
  children: [
    {
      path: "/private_allocation",
      component: Allocation,
      name: "Offers",
      meta: {
        groupName: "Private Sale",
      },
    },
  ],
};

export default (router) => {
  router.addRoutes([moduleRoute]);
};
